import { cn } from "@/lib/utils";

interface ScoreBadgeProps {
	score: number;
	max?: number;
	size?: "sm" | "md" | "lg";
}

export function ScoreBadge({ score, max = 10, size = "md" }: ScoreBadgeProps) {
	const percentage = (score / max) * 100;
	const color =
		percentage >= 70
			? "text-emerald-400 bg-emerald-400/10 border-emerald-400/20"
			: percentage >= 40
				? "text-amber-400 bg-amber-400/10 border-amber-400/20"
				: "text-red-400 bg-red-400/10 border-red-400/20";

	return (
		<span
			className={cn(
				"inline-flex items-center justify-center rounded-md border font-mono font-bold",
				color,
				size === "sm" && "h-6 min-w-[24px] px-1 text-xs",
				size === "md" && "h-8 min-w-[32px] px-1.5 text-sm",
				size === "lg" && "h-12 min-w-[48px] px-2 text-xl"
			)}
		>
			{score}/{max}
		</span>
	);
}

export function OverallScore({ score }: { score: number }) {
	const color =
		score >= 70
			? "from-emerald-500 to-emerald-400"
			: score >= 40
				? "from-amber-500 to-amber-400"
				: "from-red-500 to-red-400";

	const ringColor =
		score >= 70
			? "border-emerald-400/30"
			: score >= 40
				? "border-amber-400/30"
				: "border-red-400/30";

	return (
		<div
			className={cn(
				"relative flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full border-2",
				ringColor
			)}
		>
			<span className={cn("bg-gradient-to-b bg-clip-text text-2xl font-black text-transparent", color)}>
				{score}
			</span>
		</div>
	);
}
